import React from "react";
import { Trans } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRightLong } from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";
import { goTo } from "../utilities/utils";

interface myAccountButtonProps {
  partnerPortal?: boolean;
}

const MyAccountButton: React.FC = (props: myAccountButtonProps) => {
  return (
    <AccountButton // href="https://myaccount.gophonebox.com/login"
      partner={props.partnerPortal}
      href={
        props.partnerPortal ? "https://partner.gophonebox.com/" : "/account"
      }
      onClick={(e) => {
        e.preventDefault();
        props.partnerPortal
          ? window.location.replace("https://partner.gophonebox.com/")
          : goTo("/account");
      }}
    >
      <AccountButtonText>
        {props.partnerPortal ? (
          <Trans>Partner Portal</Trans>
        ) : (
          <Trans>My Account</Trans>
        )}
      </AccountButtonText>
      <AccountButtonIcon>
        <FontAwesomeIcon icon={faRightLong} />
      </AccountButtonIcon>
    </AccountButton>
  );
};

const AccountButtonIcon = styled.span`
  transition: opacity 0.08s ease-out;
  position: absolute;
  right: 14px;
  opacity: 0;
  color: white;
  display: inline-block;
  margin-top: 1px;
`;

const AccountButtonText = styled.span`
  transition: transform 0.08s ease-out;
  color: white;
  white-space: nowrap;
  display: inline-block;
  transform: translate(0, 0);
`;

const AccountButton = styled.a<{ partner: boolean }>`
  cursor: pointer;
  border-radius: 19px;
  background-image: linear-gradient(to bottom, #0194e9, #35c1d0);
  border: none;
  color: white;
  text-align: center;
  padding: 6px 22px;
  font-weight: bold;
  width: ${(props) => (props.partner ? "205px" : "165px")};
  position: relative;

  &:hover ${AccountButtonIcon} {
    opacity: 1;
  }

  &:hover ${AccountButtonText} {
    transform: translate(-15px, 0);
  }
`;

export default MyAccountButton;
